import api from "./base-api"
import {v4 as uuidv4} from 'uuid';

const bermudaAnalyticalDataApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getConsumablesV1: build.query({
            query: (
                data
            ) => {
                return `v1/bermuda/analytical-data/${data.userId}/consumables?limit=${data.limit}&page=0&minusDays=${data.minusDays}`
            },
            transformResponse: (response) => {
                const rows = response.map((row) => ({id: uuidv4(), ...row}));
                return {rows};
            },
        }),
        getEnvironmentsV1: build.query({
            query: (
                userId = "",
                limit = 1,
                page = 0
            ) => `v1/bermuda/analytical-data/${userId}/environments?limit=${limit}&page=${page}`
        }),
        getPaymentsV1: build.query({
            query: (
                userId = "",
                limit = 200,
                page = 0
            ) => `v1/bermuda/analytical-data/${userId}/payments?limit=${limit}&page=${page}`
        }),
        getUserInfoV1: build.query({
            query: (
                userId = "",
                limit = 200,
                page = 0
            ) => `v1/bermuda/analytical-data/${userId}/user-info?limit=${limit}&page=${page}`
        }),
    }),
    overrideExisting: false
})

export const {
    useGetConsumablesV1Query,
    useGetEnvironmentsV1Query,
    useGetPaymentsV1Query,
    useGetUserInfoV1Query,

} = bermudaAnalyticalDataApiV1
